import React, { FC } from 'react';
import { Grid, Divider } from '@mui/material';
import MessageList from './event-list';
import TextMessageInput from './features/text-message-input';

const Chat: FC = () => {
  return (
    <Grid
      container
      direction="row"
      component="div"
      sx={{
        minHeight: { xs: 300, sm: 400 },
        height: '100%',
        maxWidth: { xs: '280px', sm: '360px', md: '580px', lg: '740px' },
        mt: 2
      }}
      alignItems="flex-end"
    >
      <Grid item xs={12}>
        <MessageList />
      </Grid>
      <Grid item xs={12}>
        <Divider
          sx={{
            width: '100%'
          }}
        />
        <TextMessageInput />
      </Grid>
    </Grid>
  );
};

export default Chat;
